<template class="template-simulated-dialogue">
    <div class="simulated-dialogue" style="position:relative">
        <div class="content-pc">
            <div class="message-content">
                <div class="basic-info">
                    <div style="padding:16px 24px">
                        <span style="color:rgba(51, 51, 51, 1);font-size:18px;float:left;font-weight:bold">历史会话基本信息</span>
                        <a-button @click="getUrl" type="primary" style="background:rgba(34, 215, 187, 1);float:right;border-color:rgba(34, 215, 187, 1)">
                            复制链接
                        </a-button>
                        <textarea style="position:fixed;z-index:-10000;left:-1000" id="copyHtml"></textarea>
                    </div>
                    <div style="clear:both"></div>
                    <a-divider style="margin:16px 0 24px 0" />
                    <div style="padding:0 24px 24px 24px;flex: 1;overflow-y: auto;">
                        <div style="margin-top:24px;">
                            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">分机号码：</div>
                            <div style="color:rgba(34, 215, 187, 1);font-size:14px;">{{callDetails.phone}}</div>
                        </div>
                        <div style="margin-top:24px;">
                            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">所属项目：</div>
                            <div style="color:rgba(153, 153, 153, 1);font-size:14px;">{{callDetails.projectName}}</div>
                        </div>
                        <div style="margin-top:24px;">
                            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">通话时长：</div>
                            <div style="color:rgba(153, 153, 153, 1);font-size:14px;">{{secondToDate(callDetails.voiceDuration)}}</div>
                        </div>
                        <div style="margin-top:24px;">
                            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">用户标签：</div>
                            <div>
                                <span v-for="(item, index) in callDetails.labelList" :key="index" style="display:inline-block;padding:0px 10px;margin-right:8px;margin-top:3px;color:rgba(153, 153, 153, 1);border:1px solid rgba(233, 233, 233, 1);border-radius:2px;font-size:12px;background:rgba(233, 233, 233, 0.2);height:28px;line-height:28px;">{{item}}</span>
                            </div>
                        </div>
                        <div class="artificial-tags" style="margin-top:24px;">
                            
                            <div class="selected-tags">
                                <span v-for="(item,index) in hasSelectedTag" :key='index'>
                                    {{item.name}}
                                    <a-icon @click="deleteSelectedTag(item.id)" type="close" />
                                </span>
                            </div>
                            <a-button v-if="!ifArtificialTag" @click="addTags" icon="plus" :size="size">
                                人工标签
                            </a-button>
                            <div v-if="ifArtificialTag" class="all-tags">
                                <span @click="chooseCurrentTag(item.id, index)" :class="{'active':boolActiveList[index]}" v-for="(item,index) in allTags" :key='index'>{{item.name}}</span>
                            </div>
                            <a-button style="width:112px;" v-if="ifArtificialTag" @click="sureAddTag" type="primary">
                                确认
                            </a-button>
                        </div>
                    </div>
                    
                </div>
                <div class="info">
                    <div class="info-content info-content-message" style="padding-top:0px;padding-bottom:64px;overflow-y: auto;">
                        <div v-for="(item, index) in callDetails.recordList" :key="index" class="dialog-list">
                            <div v-if="item.word!=''" :class="{'left':item.role=='1', 'right':item.role=='2'}" style="max-width:70%">
                                <div v-if="item.role=='1'" :class="{'bgleft':item.role=='1'}">
                                    <img src="../../assets/img/chart.png" v-if="item.role=='1'" :class="{'left':item.role=='robot'}" alt="" style="margin-left:0px;">
                                    <div style="max-width:430px;background:#fff;border-radius:4px;padding:8px;" class="content-info" :class="{'right':item.role=='1'}">
                                        <div style="font-size:14px">{{item.word}}</div>
                                    </div>
                                </div>
                                <div v-if="item.role=='2'" :class="{'bgright':item.role=='2'}" @click="queryMsgIntentionData(item.id,item.word)" style="cursor:pointer">
                                    <img src="https://mikecc-sass.oss-cn-beijing.aliyuncs.com/logo/admin_0.png" v-if="item.role=='2'" :class="{'right':item.role=='user'}" alt="" style="margin-right:0px;">
                                    <div style="max-width:430px;background:rgba(34, 215, 187, 1);border-radius:4px;padding:8px;" class="content-info" :class="{'left':item.role=='2'}">
                                        <div style="font-size:14px">{{item.word}}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="clear:both"></div>
                            <div v-if="item.word!=''">
                                <div class="chat-time chat-time1" v-if="item.role=='1'" style="font-size:12px;text-align:left;float:left;margin-left:40px">{{item.time}}</div>
                                <div class="chat-time chat-time2" v-if="item.role=='2'" style="font-size:12px;text-align:right;float:right;margin-right:40px">{{item.time}}</div>
                            </div>
                        </div>
                    </div>
                    <audio style="width:90%;position:absolute;bottom:16px;" controls :src="voiceDetailUrl"></audio>
                    <a-spin v-if="loading" style="left:50%;top:50%;position:fixed;z-index:100" />
                </div>
                <div class="detail-content" v-if="ifLogin">
                    <div style="height:125px;">
                        <div>
                            <span style="color:rgba(80, 80, 80, 1);font-size:18px;float:left;">纠错学习</span>
                            <a-button @click="gotoTrain" type="primary" style="background:rgba(34, 215, 187, 1);float:right;border-color:rgba(34, 215, 187, 1)">
                                前往训练
                            </a-button>
                        </div>
                        <div style="clear:both"></div>
                        <div style="display:flex">
                            <div style="flex:1">
                                <div style="margin-top:16px;">
                                    <span style="color:rgba(204, 204, 204, 1);font-size:14px;">已训练：</span>
                                    <span style="color:rgba(34, 215, 187, 1);font-size:14px;">{{trainedCount}}</span>
                                
                                </div>
                                <div style="margin-top:16px;padding-bottom:16px;border-bottom:1px solid rgba(238, 238, 238, 1)">
                                    <span style="color:rgba(204, 204, 204, 1);font-size:14px;">待训练：</span>
                                    <span style="color:rgba(34, 215, 187, 1);font-size:14px;">{{unTrainedCount}}</span>
                                </div>
                            </div>
                            <span v-if="showDirtyBtn" @click="joinDirtyLibrary" style="display:inline-block;width:85px;margin-top:37px;height:25px;color:rgba(34, 215, 187, 1);font-size:14px;cursor:pointer">加入脏字符</span>
                        </div>
                    
                    </div>
                    <div style="clear:both"></div>
                    <ul style="flex:1;overflow-y:auto">
                        <li v-for="(item, index) in intentionList" :key="index" style="position:relative;padding-left:0px;display:flex;border-bottom:1px solid rgba(238, 238, 238, 1);font-size:12px;padding:16px 0">
                            <div style="flex:1">
                                <div style="text-align:left;color:rgba(204, 204, 204, 1)">意图</div>
                                <div style="color:rgba(80, 80, 80, 1)">{{item.name}}</div>
                            </div>
                            <div style="display:inline-block;width:50px;text-align:center">
                                <div style="color:rgba(204, 204, 204, 1)">分值</div>
                                <div style="color:rgba(80, 80, 80, 1)">{{(item.score).toFixed(2)}}</div>
                            </div>
                            <div style="display:inline-block;width:50px;text-align:center">
                                <div style="color:rgba(204, 204, 204, 1)">数量</div>
                                <div style="color:rgba(80, 80, 80, 1)">{{item.sampleCount}}</div>
                            </div>
                            <span @click="addToIntention(item.name)" style="margin-top:16px;display:inline-block;width:34px;height:34px;color:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1);border-radius:4px;line-height:34px;text-align:center;cursor:pointer">训练</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="content-phone">
            <div style="height:100%;overflow-y:auto;padding-bottom:60px">
                <div class="head">
                    <span>号码：{{callDetails.phone}}</span>
                    <span>时长：{{secondToDate(callDetails.voiceDuration)}}</span>
                </div>
                <div style="clear:both"></div>
                <div class="audio" style="width:100%">
                    <audio style="width:90%;margin:6px auto;display:block" controls :src="voiceDetailUrl"></audio>
                </div>
                <div class="chat-content">
                    <div style="color:rgba(187, 187, 187, 1);font-size:12px;text-align:center;height:40px;line-height:40px">{{chatTime}}</div>
                    <div v-for="(item, index) in callDetails.recordList" :key="index" class="dialog-list">
                        <div v-if="item.word!=''" :class="{'left':item.role=='1', 'right':item.role=='2'}" style="max-width:100%;">
                            <div v-if="item.role=='1'" :class="{'bgleft':item.role=='1'}" style="display:flex">
                                <img src="../../assets/img/chart.png" v-if="item.role=='1'" :class="{'left':item.role=='robot'}" alt="" style="margin-left:0px;margin-right:5px;width:32px">
                                <div style="background:#fff;border-radius:4px;padding:8px;flex:1" class="content-info" :class="{'right':item.role=='1'}">
                                    <div style="font-size:14px">{{item.word}}</div>
                                </div>
                            </div>
                            <div v-if="item.role=='2'" :class="{'bgright':item.role=='2'}" style="display:flex">
                                
                                <div style="background:rgba(34, 215, 187, 1);border-radius:4px;padding:8px;flex:1;float:left" class="content-info">
                                    <div style="font-size:14px">{{item.word}}</div>
                                </div>
                                <img src="https://mikecc-sass.oss-cn-beijing.aliyuncs.com/logo/admin_0.png" v-if="item.role=='2'" alt="" style="margin-right:0px;margin-left:5px;width:32px;float:right">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="phone-foot" v-if="!ifshowInfo">
                    <div>
                        <img @click="showInfo(true)" src="../../assets/img/up.svg" alt="">
                    </div>
                    <div style="color:rgba(80, 80, 80, 1)">
                        话单详情
                    </div>
                </div>
                <div class="foot-info" v-if="ifshowInfo">
                    <div style="text-align:center">
                        <img @click="showInfo(false)" src="../../assets/img/up.svg" alt="">
                    </div>
                    <div style="text-align:center;color:rgba(80, 80, 80, 1);font-size:15px">话单详情</div>
                    <div style="margin-top:15px;display:flex;">
                        <span style="display:inline-block;width:80px;color:rgba(153, 153, 153, 1);font-size:14px;">分机号码：</span>
                        <span style="flex:1;color:rgba(34, 215, 187, 1);font-size:14px;">{{callDetails.phone}}</span>
                    </div>
                    <div style="margin-top:15px;display:flex;">
                        <span style="display:inline-block;width:80px;color:rgba(153, 153, 153, 1);font-size:14px;">所属项目：</span>
                        <span style="flex:1;color:rgba(80, 80, 80, 1);font-size:14px;">{{callDetails.projectName}}</span>
                    </div>
                    <div style="margin-top:15px;display:flex;">
                        <span style="display:inline-block;width:80px;color:rgba(153, 153, 153, 1);font-size:14px;">通话时长：</span>
                        <span style="flex:1;color:rgba(80, 80, 80, 1);font-size:14px;">{{secondToDate(callDetails.voiceDuration)}}</span>
                    </div>
                    <div style="margin-top:15px;display:flex;">
                        <span style="display:inline-block;width:80px;color:rgba(153, 153, 153, 1);font-size:14px;">用户标签：</span>
                        <span style="flex:1;font-size:12px;">
                            <span v-for="(item, index) in callDetails.labelList" :key="index" style="display:inline-block;height:24px;padding:0 5px;background:rgba(34, 215, 187, 0.1);margin-right:8px;margin-top:3px" :style="{ color: randomNum() }">{{item}}</span>
                        </span>
                    </div>
                </div>
           
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SimulatedDialogue',
    props: {
        msg: String
    },
    data() {
        return {
            ifLogin:false,
            roomId: '',
            rocordId: '',
            callDetails: '',
            projectName3: '',
            voiceDetailUrl: '',
            intentionList: [],
            projectId3: '',
            msgRobbotIdList: [],
            msgCurrentWord: '',
            loading: true,
            trainedCount: 0,
            unTrainedCount: 0,
            publicChatContent: [],
            publicItem: -1,
            publicProjectId: '',
            publicRoomId: '',
            ifshowInfo: false,
            chatTime: '',
            colorList: ['rgba(34, 215, 187, 1)', '#4e8afa', '#ff8d1a', '#ca43e2'],
            showDirtyBtn: false,
            ifArtificialTag: false,
            allTags: [],
            selectTagList: [],
            boolActiveList: [],
            hasSelectedTag: []
        };
    },
    methods: {
        deleteSelectedTag(id) {
            this.axios.post('/api/callRecord/deleteManualLabel', {
                projectId: this.projectId3,
                callRecordId: this.rocordId,
                labelId: id
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功');
                    this.querySelectedTags()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        chooseCurrentTag(id, index) {
            if(this.selectTagList.indexOf(id) == -1){
                this.selectTagList.push(id)
            }else{
                let a = this.selectTagList.indexOf(id)
                this.selectTagList.splice(a,1);
            }
            if(this.boolActiveList[index]){
                this.boolActiveList[index] = false
            }else{
                this.boolActiveList[index] = true
            }
            this.$forceUpdate()
        },
        querySelectedTags() {
            this.axios({
                method:'get',
                url:'/api/callRecord/manualLabelList', 
                params: {
                    callRecordId: this.rocordId,
                }
            })
            .then(response=> {
                if(response.data.code==0){
                    this.hasSelectedTag = response.data.data
                }else{
                    this.$message.error(response.data.message)
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryAllArtificialTags() {
            this.axios({
                method:'get',
                url:'/api/callLabel/listExceptRecordLabel', 
                params: {
                    projectId: this.projectId3,
                    callRecordId: this.rocordId,
                }
            })
            .then(response=> {
                if(response.data.code==0){
                    this.boolActiveList = []
                    this.allTags = response.data.data
                    if(this.allTags.length > 0){
                        this.ifArtificialTag = true
                    }else{
                        this.$message.warning('没有可添加的标签')
                    }
                    for(let i = 0; i < this.allTags.length; i++){
                        this.boolActiveList.push(false)
                    }
                }else{
                    this.$message.error(response.data.message)
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        addTags() {
            this.queryAllArtificialTags()
        },
        sureAddTag() {
            this.ifArtificialTag = false
            if(this.selectTagList.length != 0){
                this.axios.post('/api/callRecord/addManualLabels', {
                    projectId: this.projectId3,
                    callRecordId: this.rocordId,
                    labelIdList: this.selectTagList
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('添加成功');
                        this.selectTagList = []
                        this.querySelectedTags()
                    }else{
                        this.$message.error('添加失败');
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        randomNumData(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
        randomNum() {
            let index = this.randomNumData(0,3)
            return this.colorList[index]
        },
        queryRecordDetail() {
            this.axios({
                method:'get',
                url:'/api/callRecord', 
                params: {
                    id: this.rocordId,
                    roomId: this.roomId,
                }
            })
            .then(response=> {
                this.loading = false
                this.callDetails = response.data.data
                if(response.data.data.recordList.length>0){
                    this.chatTime = response.data.data.recordList[0]['time']
                }
                this.projectName3 = response.data.data.projectName
                this.projectId3 = response.data.data.projectId
                this.voiceDetailUrl = response.data.data.voiceUrl
                this.voiceDetailUrl = this.voiceDetailUrl.replace("https","http")
                response.data.data.recordList.map((item)=>{
                    if(item.role == 1){
                        this.msgRobbotIdList.push(item.id)
                    }
                })
                if(this.ifLogin){
                    this.queryTrainSample(this.projectId3)
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryMsgIntentionData(id,word) {
            if(this.ifLogin){
                this.showDirtyBtn = true
                this.intentionList = []
                this.msgCurrentWord = word
                let nextRobbotId = ''
                for(let i = 0; i < this.msgRobbotIdList.length; i++){
                    if(this.msgRobbotIdList[i] > id){
                        nextRobbotId = this.msgRobbotIdList[i]
                        break 
                    }
                }
                if(nextRobbotId != ''){
                    this.axios({
                        method:'get',
                        url:'/api/callRecord/log', 
                        params: {
                            recordDetailId: nextRobbotId,
                            projectId: this.projectId3,
                        }
                    })
                    .then(response=> {
                        this.intentionList = response.data.data.intentionList
                    })
                    .catch(error=> {
                        console.log(error)
                    })
                }
            }
        },
        addToIntention(name) {
            this.axios.post('/api/callRecord/intention', {
                projectId: this.projectId3,
                userWords: this.msgCurrentWord,
                intention: name
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('操作成功');
                }else{
                    this.$message.success('操作失败');
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        gotoTrain() {
            this.$router.push({path: '/PublicPart/IntentionTrain',query:{projectId:this.projectId3,projectName:this.projectName3}});
        },
        queryTrainSample(id) {
            this.axios({
                method:'get',
                url:'/api/intention/statistic', 
                params: {
                    projectId: id
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.trainedCount = response.data.data.trainedCount
                    this.unTrainedCount = response.data.data.unTrainedCount
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        secondToDate(result) {
            let h = Math.floor(result / 3600);
            let m = Math.floor((result / 60 % 60));
            let s = Math.floor((result % 60));
            return result = (h!=0?h+"小时":"") + (m!=0?m+"分":"") + s + "秒";
        },
        getUrl() {
            let text = window.location.href
            let input = document.getElementById("copyHtml");
            input.value = text; 
            input.select(); 
            document.execCommand("copy"); 
            this.$message.success('复制成功');
        },
        showInfo(bool) {
            this.ifshowInfo = bool
        },
        joinDirtyLibrary() {
            this.$message.success('操作成功');
        }
    },
    mounted: function() {
        this.roomId = this.$route.query.roomId
        this.rocordId = this.$route.query.id
        this.queryRecordDetail()
        this.querySelectedTags()
        if(this.sessionData('get','token')){
            this.ifLogin = true
        }else{
            this.ifLogin = false
        }
    },
}
</script>

<style scoped  lang="less">
    .simulated-dialogue{
        background: rgba(240, 242, 243, 1);
        height: 100%;
        .left{
            float: left;
        }
        .right{
            float: right;
        }
        .content-pc{
            height: 100%;
            width:100%;
            margin: 0 auto;
            padding: 24px 24px 24px 24px;
            .message-content{
                display:flex;
                height:100%;
                .basic-info{
                    width:320px;
                    height:100%;
                    background: #fff;
                    margin-top:4px;
                    display: flex;
                    flex-direction: column;
                    .artificial-tags{
                        .selected-tags{
                            span{
                                display: inline-block;
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                font-size: 12px;
                                margin-right: 8px;
                                margin-bottom: 13px;
                                border-radius: 2px;
                                border: 1px solid rgba(34, 215, 187, 1);
                                color: rgba(0, 0, 0, 1);
                                background: rgba(34, 215, 187, 0.2);
                                i{
                                    cursor: pointer;
                                    margin-left: 8px;
                                }
                            }
                        }
                        .all-tags{
                            span{
                                display: inline-block;
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                color: rgba(153, 153, 153, 1);
                                font-size: 12px;
                                cursor: pointer;
                                margin-right: 8px;
                                margin-bottom: 13px;
                                border: 1px solid rgba(233, 233, 233, 1);
                                border-radius: 2px;
                            }
                            span.active{
                                border: 1px solid rgba(34, 215, 187, 1);
                                color: rgba(0, 0, 0, 1);
                                background: rgba(34, 215, 187, 0.2);
                            }
                        }
                    }
                }
                .detail-content{
                    width:320px;
                    height:100%;
                    margin-top:4px;
                    background:#fff;
                    overflow: hidden;
                    padding:24px 24px 0px;
                    display:flex;
                    flex-direction: column;
                    div{
                        color: #000;
                        font-size: 14px;
                    }
                    ul{
                        li{
                            padding: 0 0 0 10px;
                            line-height: 30px;
                        }
                    }
                }
                .info{
                    flex:1;
                    height: 100%;
                    background:rgba(255, 255, 255, 0.4);
                    margin: 4px 24px 0;
                    padding:0px 24px 0px;
                    position:relative;
                    .user-to-right{
                        position: absolute;
                        right: -5px;
                        top: 267px;
                        cursor: pointer;
                        z-index: 100;
                    }
                    .message-to-right{
                        position: absolute;
                        right: -5px;
                        top: 267px;
                        cursor: pointer;
                        z-index: 100;
                    }
                    .info-top{
                        height: 64px;
                        line-height: 64px;
                        font-size: 16px;
                        font-weight: bold;
                        padding: 0 0 0 24px;
                    }
                    .info-content{
                        height: 100%;
                        .dialog-list{
                            width: 100%;
                            float: left;
                            margin-bottom: 16px;
                            .bgleft{
                                padding: 8px 0;
                                border-radius: 8px;
                                height: 100%;
                                float: left;
                                padding-right: 10px;
                                width: 100%;
                            }
                            .bgright{
                                padding: 8px 0;
                                border-radius: 8px;
                                color: #fff;
                                height: 100%;
                                float: right;
                                padding-left: 10px;
                            }
                            img{
                                width: 32px;
                                height: 32px;
                                border-radius: 16px;
                                margin-right: 10px;
                                margin-left: 10px;
                            }
                            font-size: 12px;
                        }
                    }
                    .info-content-message{
                        .dialog-list{
                            position: relative;
                        }
                        .chat-time{
                            display: none;
                        }
                        .chat-time1{
                            position: absolute;
                            left:0px;
                            bottom:-16px;
                        }
                        .chat-time2{
                            position: absolute;
                            right:0px;
                            bottom:-16px;
                        }
                        .dialog-list:hover{
                            .chat-time{
                                display: inline-block;
                            }
                        }
                    }
                }
            }
          
        }
        .content-phone{
            display: none;
        }
        @media only screen and (max-width: 770px) {
            .content-pc {
                display: none;
            }
            .content-phone{
                display: block;
                width: 100%;
                height: 100%;
                .head{
                    height: 40px;
                    line-height: 40px;
                    width: 100%;
                    background: rgba(240, 240, 240, 1);
                    position: fixed;
                    top:0px;
                    left:0px;
                    span{
                        color: rgba(51, 51, 51, 1);
                        font-size: 15px;
                        margin-left:20px;
                        float: left;
                    }
                    img{
                        width:18px;
                        float: right;
                        margin: 10px 10px 0 0;
                    }
                }
                .audio{
                    height: 44px;
                    width: 100%;
                    background:#fff;
                    position: fixed;
                    top:40px;
                    left:0px;
                    audio{
                        height: 36px;
                        background: #fff;
                    }
                } 
                .phone-foot{
                    position: fixed;
                    bottom: 0px;
                    width: 100%;
                    height: 50px;
                    background: #fff;
                    text-align: center;
                    box-shadow: 0px -1px 9px 0px rgba(0, 0, 0, 0.04);
                    img{
                        width: 32px;
                        transform: rotate(180deg);
                    }
                }
                .foot-info{
                    position: fixed;
                    bottom: 0px;
                    width: 100%;
                    height: 229px;
                    background: #fff;
                    padding: 0 16px 16px 16px;
                    box-shadow: 0px -1px 9px 0px rgba(0, 0, 0, 0.04);
                    img{
                        width: 32px;
                    }
                }
                .chat-content{
                    padding: 84px 16px 50px;
                    img{
                        width: 24px;
                    }
                }
                .dialog-list{
                    width: 100%;
                    float: left;
                    margin-bottom: 16px;
                    .bgleft{
                        padding: 8px 0;
                        border-radius: 8px;
                        height: 100%;
                        float: left;
                        padding-right: 10px;
                        width: 100%;
                    }
                    .bgright{
                        padding: 8px 0;
                        border-radius: 8px;
                        color: #fff;
                        height: 100%;
                        float: right;
                        padding-left: 10px;
                    }
                    img{
                        width: 32px;
                        height: 32px;
                        border-radius: 16px;
                        margin-right: 10px;
                        margin-left: 10px;
                    }
                    font-size: 12px;
                }
            }
        }
    }
</style>
